const PSEUDO_LANGUAGE_CODES = new Set(['QPS', 'QPS-PLOC', 'PSEUDO', 'PS']);

const CHARACTER_MAP = {
  a: 'á',
  b: 'ƀ',
  c: 'ç',
  d: 'ď',
  e: 'ë',
  f: 'ƒ',
  g: 'ğ',
  h: 'ħ',
  i: 'ï',
  j: 'ĵ',
  k: 'ķ',
  l: 'ľ',
  m: 'm',
  n: 'ñ',
  o: 'ô',
  p: 'ρ',
  q: 'ʠ',
  r: 'ř',
  s: 'š',
  t: 'ŧ',
  u: 'ü',
  v: 'ṽ',
  w: 'ŵ',
  x: 'ẋ',
  y: 'ÿ',
  z: 'ž',
  A: 'Â',
  B: 'ß',
  C: 'Ç',
  D: 'Ð',
  E: 'Ë',
  F: 'Ƒ',
  G: 'Ğ',
  H: 'Ħ',
  I: 'Ï',
  J: 'Ĵ',
  K: 'Ҡ',
  L: 'Ŀ',
  M: 'M',
  N: 'Ñ',
  O: 'Ö',
  P: 'Þ',
  Q: 'Ǫ',
  R: 'Ř',
  S: 'Š',
  T: 'Ŧ',
  U: 'Û',
  V: 'Ṽ',
  W: 'Ŵ',
  X: 'Ж',
  Y: 'Ÿ',
  Z: 'Ž',
};

const maskPlaceholders = (value = '') => {
  const placeholders = [];
  const maskedText = String(value).replace(/\{[^{}]+\}/g, (placeholderText) => {
    const marker = `__PH_${placeholders.length}__`;
    placeholders.push(placeholderText);
    return marker;
  });

  return { maskedText, placeholders };
};

const unmaskPlaceholders = (value = '', placeholders = []) =>
  placeholders.reduce(
    (acc, placeholderText, index) => acc.replace(new RegExp(`__PH_${index}__`, 'g'), placeholderText),
    String(value)
  );

const pseudoLocalizeMaskedText = (value = '') =>
  String(value)
    .split('')
    .map((character) => CHARACTER_MAP[character] || character)
    .join('');

export const normalizePseudoLanguageCode = (languageCode = '') =>
  String(languageCode || '').trim().toUpperCase().replace('_', '-');

export const isPseudoLocalizationLanguage = (languageCode = '') =>
  PSEUDO_LANGUAGE_CODES.has(normalizePseudoLanguageCode(languageCode));

export const pseudoLocalizeText = (value = '') => {
  const { maskedText, placeholders } = maskPlaceholders(value);
  const pseudoLocalizedText = pseudoLocalizeMaskedText(maskedText);
  const restoredText = unmaskPlaceholders(pseudoLocalizedText, placeholders);
  return `⟪${restoredText}⟫`;
};
